import { render, staticRenderFns } from "./mainCategoryProduct.vue?vue&type=template&id=d3dd6148&scoped=true"
import script from "./mainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./mainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./mainCategoryProduct.vue?vue&type=style&index=0&id=d3dd6148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dd6148",
  null
  
)

export default component.exports